import { useContext } from 'react';

import { PlatformsContext } from '@/contexts';

export const usePlatformsContext = () => {
	const platformContext = useContext(PlatformsContext);
	return platformContext;
};
